import * as Sentry from "@sentry/browser";
import { validNavigations } from "../data/config";

export function handleError(error, msg) {
  Sentry.captureMessage(msg);
  Sentry.captureException(error);
  return {
    success: false,
    errorMessages: [msg],
    data: [],
  };
}

// Retries a failed api call (one that resolves to { success: false, ... } via handleError)
// a few times with a short delay before giving up, so transient failures don't immediately
// dead-end the user. apiCall is a zero-arg function so each attempt is a fresh request.
export async function fetchWithRetry(apiCall, maxAttempts = 3, delayMs = 1500) {
  let response;
  for (let attempt = 1; attempt <= maxAttempts; attempt++) {
    response = await apiCall();
    if (response.success) {
      return response;
    }
    if (attempt < maxAttempts) {
      await new Promise((resolve) => setTimeout(resolve, delayMs));
    }
  }
  return response;
}

export function isNavigationValid(prop, path) {
  if (typeof prop === "undefined") {
    return false;
  }

  if (typeof prop.location.state === "undefined") {
    return false;
  }

  const from = prop.location.state.from;
  const navPaths = validNavigations[path];
  return navPaths.includes(from);
}

export function _setErrorClass(errors, fieldName, isLabel) {
  if (errors.length > 0) {
    if (errors.includes(fieldName)) {
      return isLabel ? "error-class-label" : "error-class";
    }
    return "";
  }
}
